var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownload = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m12 14-.354.354.354.353.354-.353zm.5-9a.5.5 0 0 0-1 0zM6.646 9.354l5 5 .708-.708-5-5zm5.708 5 5-5-.708-.708-5 5zM12.5 14V5h-1v9z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  d: "M5 16v1a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-1"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
export default ForwardRef;